var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-icon',{attrs:{"color":this.color,"size":this.size}},[_vm._v("mdi-water")]),_vm._v(" "+_vm._s(this.color)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }